/**
 * Handles clicks on the in-cart upsell "Add" button (cart-upsell-feeder.liquid).
 * Adds the item via the Cart AJAX API, then dispatches the theme's cart:update
 * event so the existing cart-items-component refreshes itself - same signal
 * the theme's native add-to-cart button relies on.
 */
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cart-upsell-add]');
  if (!button) return;

  event.preventDefault();

  const card = button.closest('[data-cart-upsell]');
  const variantId = button.dataset.variantId;
  if (!variantId || !card || card.hasAttribute('data-loading')) return;

  card.setAttribute('data-loading', '');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status) {
        throw new Error(data.description || 'Could not add item to cart');
      }

      card.setAttribute('data-added', '');

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: data, sourceId: 'cart-upsell-feeder', data: {} },
        })
      );
    })
    .catch((error) => {
      console.error(error);
      card.removeAttribute('data-loading');
    });
});
